class HeaderParentNav extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.navChangeEvent = new CustomEvent('nav:changed', { bubbles: false })
  }

  connectedCallback () {
    super.connectedCallback()

    this.handleNavParentClick = this.handleNavParentClick.bind(this)

    this.querySelectorAll('[data-nav-parent]').forEach(item => {
      item.addEventListener('click', event => this.handleNavParentClick(event))
    })
  }

  async storeSelectionToCart (selection) {
    if (!selection) {
      return
    }

    const body = {
      attributes: {
        nav_selection: selection,
      },
    }
    try {
      await this.updateCart(body)
    } catch (error) {
      console.error('Error while adding to cart: ', error)
    }
  }

  async handleNavParentClick (event) {
    const itemEl = event.currentTarget
    const navParent = itemEl.dataset.navParent
    const navItems = document.querySelectorAll('[data-nav-parent]')
    const navMenus = document.querySelectorAll('[data-nav-menu]')
    const navMenu = document.querySelectorAll(`[data-nav-menu="${navParent}"]`)

    await this.storeSelectionToCart(navParent)

    navItems.forEach(navItem => {
      navItem.classList.remove('hd-Banner_Item-active')
    })

    navMenus.forEach(navMenu => {
      navMenu.setAttribute('aria-hidden', 'true')
    })

    navMenu.forEach(menu => {
      menu.setAttribute('aria-hidden', 'false')
    })

    itemEl.classList.add('hd-Banner_Item-active')

    document.dispatchEvent(this.navChangeEvent)
  }

  async updateCart (body) {
    return window.BAO.Cart.cartUpdate(body)
  }
}

if (!customElements.get('header-parent-nav')) {
  customElements.define('header-parent-nav', HeaderParentNav)
}
